import { NotificationsAPI } from 'api/build/notificationsAPI';

export * from 'api/build/notificationsAPI';
// eslint-disable-next-line
export default new NotificationsAPI();
